module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAICAYAAAAftBSpAAAAWUlEQVQoU6XQsQ2AMAwEwMs4iJ6WBdiCsViGnk3oqUGW6AhJEN/+62Q5acuIhDU3j6KWDts9mnJQCxKbBTMOPKAWJI4oQq1IEfqCvEKBnLXPFvr4Uf8X2TFckr8TRxrhl7MAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/views/home/assets/arrow3.png
// module id = zemM
// module chunks = 4